<button
  type="button"
  class="btn-impressao"
  [disabled]="disabled"
  [class.esmaecido]="esmaecido"
  (click)="onClick()"
>
<p>Imprimir detalhe</p>
  <img *ngIf="icon" [src]="icon" alt="Ícone de impressão" />
</button>
